(function () {
  let shareToastElement = null;
  let shareToastTimeout = null;

  const showShareToast = (message) => {
    if (!message) {
      return;
    }

    if (!shareToastElement) {
      shareToastElement = document.createElement('div');
      shareToastElement.className = 'article-share__toast';
      shareToastElement.setAttribute('role', 'status');
      shareToastElement.setAttribute('aria-live', 'polite');
      document.body.appendChild(shareToastElement);
    }

    shareToastElement.textContent = message;
    shareToastElement.classList.add('is-visible');

    if (shareToastTimeout) {
      window.clearTimeout(shareToastTimeout);
    }

    shareToastTimeout = window.setTimeout(() => {
      shareToastElement.classList.remove('is-visible');
    }, 2500);
  };

  const getShareData = (shareRoot) => {
    return {
      url: shareRoot.dataset.shareUrl || '',
      title: shareRoot.dataset.shareTitle || '',
      image: shareRoot.dataset.shareImage || '',
      copyMessage: shareRoot.dataset.shareCopyMessage || '',
    };
  };

  const buildShareUrl = (platform, shareData) => {
    const encodedUrl = encodeURIComponent(shareData.url);
    const encodedTitle = encodeURIComponent(shareData.title);
    const encodedImage = encodeURIComponent(shareData.image);

    if (platform === 'facebook') {
      return `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`;
    }

    if (platform === 'x') {
      return `https://x.com/share?url=${encodedUrl}&text=${encodedTitle}`;
    }

    if (platform === 'pinterest') {
      return `https://pinterest.com/pin/create/button/?url=${encodedUrl}&media=${encodedImage}&description=${encodedTitle}`;
    }

    if (platform === 'linkedin') {
      return `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`;
    }

    if (platform === 'whatsapp') {
      return `https://wa.me/?text=${encodeURIComponent(`${shareData.url} - ${shareData.title}`)}`;
    }

    if (platform === 'telegram') {
      return `https://t.me/share/url?url=${encodedUrl}&text=${encodedTitle}`;
    }

    return '';
  };

  const initArticleShare = (root) => {
    const shareBlocks = root.querySelectorAll('[data-article-share]');

    shareBlocks.forEach((share) => {
      if (share.dataset.articleShareInitialized === 'true') {
        return;
      }

      const copyButton = share.querySelector('[data-article-share-copy]');
      const platformButtons = share.querySelectorAll('[data-article-share-platform]');

      platformButtons.forEach((platformButton) => {
        platformButton.addEventListener('click', () => {
          const platform = platformButton.dataset.articleSharePlatform;
          const shareData = getShareData(share);
          const shareUrl = buildShareUrl(platform, shareData);

          if (!shareUrl) {
            return;
          }

          window.open(shareUrl, '_blank', 'noopener,noreferrer');
        });
      });

      if (copyButton) {
        copyButton.addEventListener('click', async () => {
          const shareData = getShareData(share);

          if (!shareData.url) {
            return;
          }

          try {
            if (navigator.clipboard && navigator.clipboard.writeText) {
              await navigator.clipboard.writeText(shareData.url);
            } else {
              const textArea = document.createElement('textarea');
              textArea.value = shareData.url;
              textArea.setAttribute('readonly', '');
              textArea.style.position = 'absolute';
              textArea.style.left = '-9999px';
              document.body.appendChild(textArea);
              textArea.select();
              document.execCommand('copy');
              document.body.removeChild(textArea);
            }

            copyButton.classList.add('is-copied');
            showShareToast(shareData.copyMessage);

            window.setTimeout(() => {
              copyButton.classList.remove('is-copied');
            }, 1500);
          } catch (error) {
            copyButton.classList.remove('is-copied');
          }
        });
      }

      share.dataset.articleShareInitialized = 'true';
    });
  };

  const boot = (scope) => {
    const root =
      scope && scope.matches && scope.matches('.static-page--article')
        ? scope
        : document.querySelector('.static-page--article');

    if (!root) {
      return;
    }

    initArticleShare(root);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot(document));
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    boot(event.target);
  });
})();
